import { paymentSlice } from "@entities/Payment/model/payment.slice";

const paymentActions = paymentSlice.actions;
const paymentSelectors = paymentSlice.selectors;

export { paymentSlice, paymentActions, paymentSelectors };
